import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, vShow as _vShow, withDirectives as _withDirectives, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/icons/arrow-customize-builder-back.svg'
import _imports_1 from '@/assets/icons/arrow-customize-builder.svg'


const _hoisted_1 = { class: "content-buttons" }
const _hoisted_2 = { class: "back-text" }
const _hoisted_3 = { class: "next-text" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["container-buttons", { isFirstStep: $setup.isFirstStep }])
  }, [
    _createElementVNode("div", _hoisted_1, [
      _withDirectives(_createElementVNode("button", {
        class: "button button-prev",
        onClick: $setup.onSelectPrev
      }, [
        _cache[0] || (_cache[0] = _createElementVNode("img", {
          class: "reverse",
          src: _imports_0
        }, null, -1)),
        _createElementVNode("span", _hoisted_2, _toDisplayString($setup.backStepTextButton), 1)
      ], 512), [
        [_vShow, !$setup.isFirstStep]
      ]),
      _createElementVNode("button", {
        class: _normalizeClass(["button button-next", { 'next-disabled': $setup.nextButtonIsDisabled }]),
        onClick: $setup.onSelectNext
      }, [
        _createElementVNode("span", _hoisted_3, _toDisplayString($setup.nextStepTextButtonControlled), 1),
        _cache[1] || (_cache[1] = _createElementVNode("img", {
          class: "next",
          src: _imports_1
        }, null, -1))
      ], 2)
    ])
  ], 2))
}